module.exports = __webpack_public_path__ + "img/44ne.436f9a22.svg";